"use strict";

exports.__esModule = true;
exports.FiltersController = FiltersController;
var _isEmpty2 = _interopRequireDefault(require("ramda/src/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
var _RestAPI = require("../../API/RestAPI");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _TimePeriodController = require("../../Time/TimePeriodController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function FiltersController(props) {
  var dataRange = props.dataRange,
    children = props.children;
  var api = _react["default"].useContext(_RestAPI.RestAPIContext);
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  return /*#__PURE__*/_react["default"].createElement(_SelectedDevicesController.SelectedDevicesController, null, function (device) {
    var deviceList = (0, _isEmpty2["default"])(device) ? devices.map(function (d) {
      return d.uuid;
    }) : device;
    return /*#__PURE__*/_react["default"].createElement(_TimePeriodController.TimePeriodController, {
      dataRange: dataRange
    }, function (_ref) {
      var interval = _ref.interval;
      var startMillis = interval.startMillis,
        endMillis = interval.endMillis;
      return children({
        device: deviceList,
        plant: api.plantName,
        WorkdayRangeSelector: {
          gte: new Date(startMillis).toISOString(),
          lt: new Date(endMillis).toISOString()
        }
      });
    });
  });
}